import React, {useState} from 'react';
import FilterIndustry from './filter-industry';
import FilterSpots from './filter-spots';
import StickyComponent from './sticky-component';

const CustomerStoryFilters = (props) => {
  const moreFilters = Drupal.t('More filters');
  const lessFilters = Drupal.t('Less filters');
  const [toggleFilters, setToggleFilters] = useState(moreFilters);

  // Reset filters and scroll to top of the app.
  const resetFilters = (e) => {
    e.preventDefault();
    props.setFilters({
      audience: '',
      spots: '',
      industry: '',
      page: 0
    });
  }

  // Show filters on mobile.
  const showFilters = (e) => {
    e.preventDefault();
    document.querySelector('.filters').classList.toggle('filters-collapsed');
    setToggleFilters(toggleFilters === moreFilters ? lessFilters : moreFilters);
  }

  return (
    <StickyComponent>
      <FilterSpots selected={props.filters.spots} setFilters={props.setFilters} filters={props.filters} />

      {(props.dataFilters && Object.entries(props.dataFilters.industry).length > 0) && (
        <FilterIndustry industry={props.dataFilters.industry} checked={props.filters.industry} setFilters={props.setFilters} filters={props.filters} />
      )}

      {(props.filters.audience || props.filters.spots || props.filters.industry) && (
        <div className='reset-filters'>
          <a href="#" onClick={resetFilters}>
            {Drupal.t('Reset filters')}
          </a>
        </div>
      )}

      <div className='mobil-filter' onClick={showFilters}>
        <span>{toggleFilters}</span>
        <i className="arrow"></i>
      </div>
    </StickyComponent>
  );
};

export default CustomerStoryFilters;